<div class="container">
    <h2 class="pb-3 mt-3">Shopping Cart</h2>
  
    <div class="row">
        <main class="col-md-9">
            <article class="card card-body mb-3" *ngFor="let item of allCarttems">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <figure class="itemside">
                            <div class="aside"><img src="{{item.ImagePath || item.productImage.imagepath}}"
                                    class="border img-sm">
                            </div>
                            <figcaption class="info">
                                <span class="text-muted">{{item.ProductName || item.productName}}</span>
                                <a routerLink="#" class="title">{{item.Description || item.productDesc}} </a>
                            </figcaption>
                        </figure>
                    </div> <!-- col.// -->
                    <div class="col">
                        <div class="col-md-5 text-md-right text-right">
                            <div class="input-group input-spinner">
                                <div class="input-group-prepend">
                                    <button class="btn btn-light" (click)="updateCart('plus',item)" type="button"
                                        id="button-plus"> <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                                <input type="text" readonly class="form-control" value="{{item.selectedQuantity}}">
                                <div class="input-group-append">
                                    <button class="btn btn-light" (click)="updateCart('minus',item)" type="button"
                                        id="button-minus"> <i class="fa fa-minus"></i>
                                    </button>
                                </div>
                            </div> <!-- input-group.// -->
                        </div>
                    </div> <!-- col.// -->
                    <div class="col">
                        <div class="price h5"> Rs {{item.Cost * item.selectedQuantity || item.productprice
                            *item.selectedQuantity}} </div>
                    </div>
                    <div class="col flex-grow-0 text-right">
                        <a (click)="remove(item)" class="btn btn-light"> <i class="fa fa-times"></i> </a>
                    </div>
                </div> <!-- row.// -->
            </article>

        </main>
        <aside class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" name="" placeholder="Promo code">
                        <span class="input-group-append">
                            <button class="btn btn-theme">Ok</button>
                        </span>
                    </div>
                    <!-- <dl class="dlist-align">
                        <dt>Subtotal:</dt>
                        <dd class="text-right">$938.50</dd>
                    </dl>
                    <dl class="dlist-align">
                        <dt>Discount:</dt>
                        <dd class="text-right text-danger">10%</dd>
                    </dl> -->
                    <dl class="dlist-align">
                        <dt>Grand Total:</dt>
                        <dd class="text-right text-dark"><strong>Rs {{TotalOfAllItems}}</strong></dd>
                    </dl>
                    <hr>
                 


                        <a (click)="purchaseItems()" class="btn btn-theme btn-block"> Make a request </a>

      
                </div> <!-- card-body.// -->
            </div> <!-- card.// -->
        </aside> <!-- col.// -->
    </div> <!-- row.// -->

    <div class="mt-3">

        <app-cat-carousel></app-cat-carousel>
    </div>


   
</div>